import { jsx as _jsx } from "react/jsx-runtime";
// $FlowFixMe
import { useEffect } from 'react';
export default function TestErrors() {
    useEffect(() => {
        throw new Error('Auto generated error for testing.');
    }, []);
    return _jsx("div", { children: "This page generate an error" });
}
